var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "renderForm",
      staticClass: "render-form",
      class: [_vm.customClass],
      attrs: {
        "label-position": _vm.labelPosition,
        size: _vm.size,
        "label-width": _vm.labelWidth,
        "validate-on-rule-change": false,
        model: _vm.formDataModel,
      },
      nativeOn: {
        submit: function ($event) {
          $event.preventDefault()
        },
      },
    },
    [
      _vm._l(_vm.widgetList, function (widget, index) {
        return [
          "container" === widget.category
            ? [
                _c(_vm.getContainerWidgetName(widget), {
                  key: widget.id,
                  tag: "component",
                  attrs: {
                    widget: widget,
                    "parent-list": _vm.widgetList,
                    "index-of-parent-list": index,
                    "parent-widget": null,
                  },
                  scopedSlots: _vm._u(
                    [
                      _vm._l(Object.keys(_vm.$scopedSlots), function (slot) {
                        return {
                          key: slot,
                          fn: function (scope) {
                            return [_vm._t(slot, null, null, scope)]
                          },
                        }
                      }),
                    ],
                    null,
                    true
                  ),
                }),
              ]
            : [
                _c(_vm.getWidgetName(widget), {
                  key: widget.id,
                  tag: "component",
                  attrs: {
                    field: widget,
                    "form-model": _vm.formDataModel,
                    designer: null,
                    "parent-list": _vm.widgetList,
                    "index-of-parent-list": index,
                    "parent-widget": null,
                  },
                  scopedSlots: _vm._u(
                    [
                      _vm._l(
                        Object.keys(_vm.$scopedSlots),
                        function (slot, index) {
                          return {
                            key: slot,
                            fn: function (scope) {
                              return [_vm._t(slot, null, null, scope)]
                            },
                          }
                        }
                      ),
                    ],
                    null,
                    true
                  ),
                }),
              ],
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }